import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentAttendance from './ContentAttendance';

const Attendance = () => {
  return (
    <>
      <Header />
      <ContentAttendance />
      <Bottom />
    </>
  );
};

export default Attendance;
